/**
 * @generated SignedSource<<591f767f26595b40630ad5db57b451c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ScriptTagSettingTabContainer_ToggleModuleMutation$variables = {
  siteId: string;
  moduleId: string;
  enabled: boolean;
};
export type ScriptTagSettingTabContainer_ToggleModuleMutationVariables = ScriptTagSettingTabContainer_ToggleModuleMutation$variables;
export type ScriptTagSettingTabContainer_ToggleModuleMutation$data = {
  readonly toggleUserTagModule: {
    readonly site: {
      readonly " $fragmentSpreads": FragmentRefs<"ScriptTagSettingTabContainer_site">;
    };
    readonly userTagModule: {
      readonly id: string;
      readonly enabled: boolean;
      readonly hasPendingToggle: boolean;
    };
  } | null;
};
export type ScriptTagSettingTabContainer_ToggleModuleMutationResponse = ScriptTagSettingTabContainer_ToggleModuleMutation$data;
export type ScriptTagSettingTabContainer_ToggleModuleMutation = {
  variables: ScriptTagSettingTabContainer_ToggleModuleMutationVariables;
  response: ScriptTagSettingTabContainer_ToggleModuleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "moduleId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "enabled",
        "variableName": "enabled"
      },
      {
        "kind": "Variable",
        "name": "moduleId",
        "variableName": "moduleId"
      },
      {
        "kind": "Variable",
        "name": "siteId",
        "variableName": "siteId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingToggle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "UserTagModule",
  "kind": "LinkedField",
  "name": "userTagModule",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionNumber",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tagContent",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authorName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPendingChanges",
  "storageKey": null
},
v18 = [
  (v4/*: any*/),
  (v15/*: any*/)
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v20 = [
  (v4/*: any*/),
  (v19/*: any*/)
],
v21 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Page",
  "kind": "LinkedField",
  "name": "page",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Funnel",
      "kind": "LinkedField",
      "name": "funnel",
      "plural": false,
      "selections": (v18/*: any*/),
      "storageKey": null
    },
    (v4/*: any*/)
  ],
  "storageKey": null
},
v23 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "moduleName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fromLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "toLabel",
    "storageKey": null
  }
],
v24 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "codeDraftModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "addedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "removedModuleNames",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "toggleChanges",
    "plural": true,
    "selections": (v23/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "UserTagToggleChange",
    "kind": "LinkedField",
    "name": "linkChanges",
    "plural": true,
    "selections": (v23/*: any*/),
    "storageKey": null
  }
],
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "versionName",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ScriptTagSettingTabContainer_ToggleModuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ToggleUserTagModulePayload",
        "kind": "LinkedField",
        "name": "toggleUserTagModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ScriptTagSettingTabContainer_site"
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ScriptTagSettingTabContainer_ToggleModuleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "ToggleUserTagModulePayload",
        "kind": "LinkedField",
        "name": "toggleUserTagModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Site",
            "kind": "LinkedField",
            "name": "site",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "embedTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "robeeTag",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userTagDraft",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagPublishedModule",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "userTagModules",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v16/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftContent",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "draftEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasDraft",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "effectiveEnabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isDraftDistributionGated",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasPendingLinkChange",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isArchive",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "popupGroups",
                    "plural": true,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "abtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroup",
                    "kind": "LinkedField",
                    "name": "draftPopupGroups",
                    "plural": true,
                    "selections": (v18/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroup",
                    "kind": "LinkedField",
                    "name": "draftAbtestScenarioPageGroups",
                    "plural": true,
                    "selections": (v20/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "PopupGroupConnection",
                "kind": "LinkedField",
                "name": "popupGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PopupGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PopupGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v15/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "popupGroups(first:500)"
              },
              {
                "alias": null,
                "args": (v21/*: any*/),
                "concreteType": "AbtestScenarioPageGroupConnection",
                "kind": "LinkedField",
                "name": "abtestScenarioPageGroups",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbtestScenarioPageGroupEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbtestScenarioPageGroup",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v19/*: any*/),
                          (v22/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "abtestScenarioPageGroups(first:500)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagModule",
                "kind": "LinkedField",
                "name": "enabledUserTagModules",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v15/*: any*/),
                  (v5/*: any*/),
                  (v16/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "draftMergedTagPreview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledModuleCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalModuleCount",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasWorkspaceDeployDrift",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagWorkspacePendingChangeSummary",
                "kind": "LinkedField",
                "name": "userTagWorkspacePendingChangeSummary",
                "plural": false,
                "selections": (v24/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "userTagVersions",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v25/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v26/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagWorkspacePendingChangeSummary",
                    "kind": "LinkedField",
                    "name": "changeSummary",
                    "plural": false,
                    "selections": (v24/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserTagVersionModuleSnapshot",
                    "kind": "LinkedField",
                    "name": "modulesSnapshot",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "moduleId",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v5/*: any*/),
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "gated",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserTagVersion",
                "kind": "LinkedField",
                "name": "activeUserTagVersion",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v25/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v26/*: any*/),
                  (v14/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "07aab49d5bb354ca50fda50ec67db932",
    "id": null,
    "metadata": {},
    "name": "ScriptTagSettingTabContainer_ToggleModuleMutation",
    "operationKind": "mutation",
    "text": "mutation ScriptTagSettingTabContainer_ToggleModuleMutation(\n  $siteId: ID!\n  $moduleId: ID!\n  $enabled: Boolean!\n) {\n  toggleUserTagModule(input: {siteId: $siteId, moduleId: $moduleId, enabled: $enabled}) {\n    site {\n      ...ScriptTagSettingTabContainer_site\n      id\n    }\n    userTagModule {\n      id\n      enabled\n      hasPendingToggle\n    }\n  }\n}\n\nfragment ScriptTagSettingTabContainer_site on Site {\n  id\n  embedTag\n  robeeTag\n  userTagDraft\n  userTagPublishedModule {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n  }\n  userTagModules {\n    id\n    versionNumber\n    tagContent\n    status\n    description\n    authorName\n    publishedAt\n    createdAt\n    name\n    enabled\n    priority\n    draftContent\n    draftEnabled\n    hasDraft\n    hasPendingToggle\n    hasPendingChanges\n    effectiveEnabled\n    isDistributionGated\n    isDraftDistributionGated\n    hasPendingLinkChange\n    isArchive\n    deletedAt\n    popupGroups {\n      id\n      name\n    }\n    abtestScenarioPageGroups {\n      id\n      title\n    }\n    draftPopupGroups {\n      id\n      name\n    }\n    draftAbtestScenarioPageGroups {\n      id\n      title\n    }\n  }\n  popupGroups(first: 500) {\n    edges {\n      node {\n        id\n        name\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  abtestScenarioPageGroups(first: 500) {\n    edges {\n      node {\n        id\n        title\n        page {\n          funnel {\n            id\n            name\n          }\n          id\n        }\n      }\n    }\n  }\n  enabledUserTagModules {\n    id\n    name\n    enabled\n    priority\n    tagContent\n  }\n  mergedTagPreview\n  draftMergedTagPreview\n  enabledModuleCount\n  totalModuleCount\n  hasPendingChanges\n  hasWorkspaceDeployDrift\n  userTagWorkspacePendingChangeSummary {\n    codeDraftModuleNames\n    addedModuleNames\n    removedModuleNames\n    toggleChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n    linkChanges {\n      moduleName\n      fromLabel\n      toLabel\n    }\n  }\n  userTagVersions {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n    content\n    changeSummary {\n      codeDraftModuleNames\n      addedModuleNames\n      removedModuleNames\n      toggleChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n      linkChanges {\n        moduleName\n        fromLabel\n        toLabel\n      }\n    }\n    modulesSnapshot {\n      moduleId\n      name\n      enabled\n      priority\n      gated\n      tagContent\n    }\n  }\n  activeUserTagVersion {\n    id\n    versionName\n    description\n    authorName\n    isActive\n    createdAt\n  }\n}\n"
  }
};
})();

(node as any).hash = "f8fa3d138d02ef456037aeb40881e9cc";

export default node;
